export const paginate = <T>(
  array: T[],
  pageSize: number,
  pageNumber: number
): T[] => {
  if (array.length <= pageSize) return array;
  return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
};
